import React from 'react'
import { useStyles } from './ContactStyle'
import { Link } from 'react-router-dom'
import img from '../../assets/images/banner.svg'

//Material UI
import Card from '@material-ui/core/Card'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import PhoneIcon from '@material-ui/icons/Phone'
import HomeIcon from '@material-ui/icons/Home'
import pdf from '../../assets/ContactCentres.pdf'

export default function Contact() {
  const classes = useStyles()

  return (
    <div className={classes.root} >
      <Card className={classes.card}>
        <div className={classes.text} >
          <div>
            <h1 style={{ width: '100%', textAlign: 'center', color: '#035ea7' }}>
                           Contacter votre centre AnimaNice
            </h1>
            <hr></hr>
            <p>
              Votre centre AnimaNice est à votre disposition tout au long de l'année
            </p>
            <hr></hr>
            
          </div>
        </div>


        <div className={classes.links}>
          <Link to={pdf} target="_blank">
            <div>
              <PhoneIcon />
              <div>
                <h3>Téléphone</h3>
                <h4>Contacter </h4>
              </div>
            </div>
          </Link>
          <Link to="#">
            <div>
              <MailOutlineIcon />
              <div>
                <h3>Par mail</h3>
                <h4>animanice.direction@ville-nice.fr</h4>
              </div>
            </div>
          </Link>
          <Link to={pdf} target="_blank">
            <div>
              <HomeIcon fontSize="large" />
              <div>
                <h3>Centre</h3>
                <h4>Voir la liste des centres</h4>
              </div>
            </div>

          </Link>
        </div>
      </Card>
    </div>
  )
}

